/* eslint-disable consistent-return */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import _ from "underscore";

import PropTypes from "prop-types";
import * as orderRepo from "../../shared/repos/graphql/order";
import * as productRepo from "../../shared/repos/graphql/product";
import Link from "../LinkWithCountry/LinkWithCountry";

import removeProductModal from "../RemoveProductModal/RemoveProductModal";

import Button from "../Button/Button";
import FeaturedLocation from "../FeaturedLocation/FeaturedLocation";

import { orderMethods, orderTypeIds } from "../../shared/constants/order";
import { shippingMethods, storeTypes } from "../../shared/constants/store";
import {
  clearCart,
  guardOrderChange,
  guardOrderChangeToPickup
} from "../../shared/utilities/orders";
import * as tagmanagerEvents from "../../shared/utilities/tagmanagerEvents";
import amplitudeAnalytics from "../../shared/utilities/amplitude";
import { isE2EStoreHoursBypassEnabled } from "../../shared/utilities/e2eFlags";

import * as countryActions from "../../redux/actions/country";
import * as elementsActions from "../../redux/actions/elements";
import * as loyaltyAction from "../../redux/actions/loyalty";
import * as userActions from "../../redux/actions/user";
import { store as mainStore } from "../../redux/store";
import endpoints from "../../shared/constants/endpoints";
import errorCodes from "../../shared/constants/errorCodes";
import {
  getErrorMessages,
  getErrorReasons,
  routeCountryPath
} from "../../shared/utilities/common";
import {
  openCartCreateFailModal,
  openOrderUpdateFailModal
} from "../../shared/utilities/modals";
import { runWithLocationAccessAcknowledgement } from "../../shared/utilities/locationAccessAcknowledgement";
import * as phoneService from "../../shared/utilities/phone";
import { isBrandRefreshEnabled } from "../../shared/utilities/brandRefresh";
import styles from "./LocationsListItem.module.css";
import "./LocationsListItemBrandRefresh.module.css";
import {
  formatBrandRefreshStoreDistance,
  formatBrandRefreshStorePhone,
  truncateBrandRefreshStoreAddress,
  getListItemContainerClass,
  getListItemWrapperClass,
} from "./locationsListItemBrandRefreshClasses";

const infoIcon = require("./imgs/info-icon.png");
const DeliveryIcon = require("./imgs/delivery.svg");
const scooterBrandRefreshIcon = require("./imgs/scooter-brand-refresh.svg");
const workIcon = require("./imgs/work-icon.png");
const brandRefreshStorefrontIcon = require("./imgs/brand-refresh-storefront.svg");

class LocationsListItem extends Component {
  componentDidUpdate(prevProps) {
    const { selectedMapStore } = this.props;
    if (prevProps !== this.props && selectedMapStore) {
      this.checkSelected();
    }
  }

  checkSelected = () => {
    const { selectedMapStore, store, onClick, isBrandRefresh } = this.props;

    if (isBrandRefresh) {
      return;
    }

    const matchingStore = store.id === selectedMapStore.id;

    if (matchingStore) {
      onClick();
    }
  };

  createCart = async (address, store) => {
    const {
      setUserCartId,
      setModalObject,
      setSelectedStore,
      setUserAddress,
      changeAddress,
      history
    } = this.props;
    const { userCartId } = mainStore.getState().user;

    if (userCartId) {
      return true;
    }

    const addressComponents = address
      ? {
          address1: address.address1,
          city: address.city,
          state: address.state,
          postcode: address.postcode,
          countryId: address.countryId,
          lat: address.lat,
          lng: address.lng
        }
      : null;

    const data = {
      storeId: store.id,
      orderTypeId: 3,
      shippingMethod: 3,
      address: addressComponents
    };

    try {
      const response = await orderRepo.createCart(data);
      const { createCart } = response.data;

      setUserCartId(createCart.code);
      setSelectedStore(store);
      setUserAddress(addressComponents);

      const { onPickupStoreAddressConfirmed } = this.props;
      if (typeof onPickupStoreAddressConfirmed === "function") {
        onPickupStoreAddressConfirmed(addressComponents);
      }

      const { preserveProductPage } = this.props;
      if (!changeAddress && !preserveProductPage) {
        history.push(
          this.redirectToPdp(routeCountryPath(endpoints.getMenuUrl(store)))
        );
      }

      setModalObject(null);
      return true;
    } catch (reason) {
      const message = getErrorMessages(reason, 0);
      const reasonType = getErrorReasons(reason, 0);
      const isCartCreateErrorReason =
        errorCodes.CART_CREATE_ERROR === reasonType;
      if (isCartCreateErrorReason) {
        setModalObject(openCartCreateFailModal(message, clearCart));
      }
      return false;
    }
  };

  updateOrdersLocation = async (userCartId, data) => {
    const {
      addressComponents,
      store,
      setUserOrderMethod,
      changeAddress,
      history,
      setModalObject,
      setSelectedStore,
      setUserAddress,
      addressSource,
      onPickupStoreAddressConfirmed,
    } = this.props;

    try {
      await orderRepo.updateOrderLocation(userCartId, data);

      setUserOrderMethod(orderMethods.pickup);

      if (typeof onPickupStoreAddressConfirmed === "function") {
        onPickupStoreAddressConfirmed(addressComponents);
      } else {
        amplitudeAnalytics.trackEnterAddress({
          fulfillmentType: "Pickup",
          addressSource: addressSource || "Saved Address",
          pathname: history.location.pathname,
          address: store.mailingAddress,
        });
      }

      const { preserveProductPage } = this.props;
      if (!changeAddress && !preserveProductPage) {
        history.push(
          this.redirectToPdp(routeCountryPath(endpoints.getMenuUrl(store)))
        );
      }
      setSelectedStore(store);
      setUserAddress(addressComponents);
      setModalObject(null);
      return true;
    } catch (reason) {
      const message = getErrorMessages(reason, 0);
      const reasonType = getErrorReasons(reason, 0);
      const isCartCreateErrorReason =
        errorCodes.ORDER_UPDATE_ERROR === reasonType;
      if (isCartCreateErrorReason) {
        setModalObject(openOrderUpdateFailModal(message));
      }
      return false;
    }
  };

  callbackHandler = async productIds => {
    const { addressComponents, store } = this.props;
    const { userCartId } = mainStore.getState().user;

    await orderRepo.removeProducts(userCartId, productIds);

    const address = {
      address1: addressComponents.address1,
      city: addressComponents.city,
      state: addressComponents.state,
      postcode: addressComponents.postcode
    };

    const data = {
      orderTypeId: orderTypeIds.pickup,
      storeId: store.id,
      address,
      shippingMethod: shippingMethods.pickup
    };

    await this.updateOrdersLocation(userCartId, data);
  };

  redirectToPdp = location => {
    const { redeemables, setRedeemableItem } = this.props;
    if (redeemables?.redeemableType) {
      setRedeemableItem({
        redeemableType: null,
        redeemableId: null
      });
      return routeCountryPath(endpoints.loyalty);
    }

    return location;
  };

  selectStore = async (e, countryChange = false) => {
    const {
      allCountries,
      setSelectedCountry,
      addressComponents,
      store,
      setUserOrderMethod,
      setModalObject,
      history,
      addressSource,
      onPickupStoreAddressConfirmed,
    } = this.props;
    const { userCartId } = mainStore.getState().user;

    if (e?.stopPropagation) {
      e.stopPropagation();
    }

    const addressCountry = allCountries.find(
      country => +country.id === +store.countryId
    );

    const proceed = async () => {
      if (countryChange) {
        setSelectedCountry(addressCountry);
      }

      if (userCartId) {
        const response = await productRepo.checkStoreProductStock(
          userCartId,
          store.id
        );
        const oosProducts =
          response?.data?.storeProductStock.filter(
            item => parseInt(item.oos, 10) === 1
          ) || [];

        if (oosProducts.length) {
          const productIds = _.pluck(oosProducts, "orderProductId");

          const callback = async () => {
            await this.callbackHandler(productIds);
          };

          return removeProductModal(setModalObject, store, oosProducts, callback);
        }
        const address = addressComponents
          ? {
              address1: addressComponents.address1,
              city: addressComponents.city,
              state: addressComponents.state,
              countryId: addressComponents.countryId,
              postcode: addressComponents.postcode
            }
          : null;

        const data = {
          orderTypeId: orderTypeIds.pickup,
          storeId: store.id,
          address,
          shippingMethod: shippingMethods.pickup
        };

        const success = await this.updateOrdersLocation(userCartId, data);
        if (success) {
          this.closeDeliveryPickupWidget();
        }
        return success;
      }
      await setUserOrderMethod("PICKUP");
      if (typeof onPickupStoreAddressConfirmed !== "function") {
        amplitudeAnalytics.trackEnterAddress({
          fulfillmentType: "Pickup",
          addressSource: addressSource || "Saved Address",
          pathname: history.location.pathname,
          address: store.mailingAddress,
        });
      }
      const success = await this.createCart(addressComponents, store);
      if (success) {
        this.closeDeliveryPickupWidget();
      }
      return success;
    };

    return runWithLocationAccessAcknowledgement(store, setModalObject, proceed);
  };

  showCountryChange = (e, store) => {
    const {
      setModalObject,
      changeAddress,
      orderProducts,
      userOrderMethod
    } = this.props;

    const currentOrderNotPickup = userOrderMethod
      ? userOrderMethod !== orderMethods.pickup
      : false;
    const hasCartItems =
      Array.isArray(orderProducts) && orderProducts.length > 0;
    const showOrderGuardModal = hasCartItems || currentOrderNotPickup;
    setModalObject({
      title:
        "You are searching for an address in another country, would you like to change your country selection?",
      description:
        "If you remain on the current country website, you may still proceed with ordering, however, all purchases will be completed in the local store currency, and your transaction and your visit to the website will be governed by the local laws.",
      action1: async () => {
        tagmanagerEvents.viewMenu(store.id);

        if (!changeAddress) {
          guardOrderChange(showOrderGuardModal, this.selectStore, e, true);
          return;
        }

        const success = await this.selectStore(e, true);
        if (success) {
          setModalObject(null);
        }
      },
      action2: async () => {
        tagmanagerEvents.viewMenu(store.id);

        if (!changeAddress) {
          guardOrderChange(showOrderGuardModal, this.selectStore, e, false);
          return;
        }

        const success = await this.selectStore(e, false);
        if (success) {
          setModalObject(null);
        }
      },
      action1Label: "Yes",
      action2Label: "No"
    });
    return true;
  };

  closeDeliveryPickupWidget() {
    const { closePopup } = this.props;
    if (closePopup) {
      closePopup();
    }
  }

  render() {
    const {
      onClick,
      name,
      storeImage,
      isOpen,
      distanceFrom,
      store,
      mailingAddress,
      city,
      state,
      zip,
      telephone,
      phonePrefixes,
      changeAddress,
      isDeliveryInRange,
      isCountrySelectActive,
      selectedCountry,
      onViewMenuClick,
      orderProducts,
      userOrderMethod,
      featuredLocation,
      isBrandRefresh,
      hoursStatusText,
      address,
    } = this.props;

    const currentOrderNotPickup = userOrderMethod
      ? userOrderMethod !== orderMethods.pickup
      : false;
    const hasCartItems =
      Array.isArray(orderProducts) && orderProducts.length > 0;
    const showOrderGuardModal = hasCartItems || currentOrderNotPickup;
    // Hours drive Open/Closed label; View Menu follows API isPickupOpen too
    // (same as pickup widget / legacy list) so E2E is not blocked by US hours.
    const canOrder =
      (isOpen ||
        !!store.isPickupOpen ||
        isE2EStoreHoursBypassEnabled()) &&
      store.storeType !== storeTypes.COMINGSOON;

    const viewMenu = async e => {
      if (
        isCountrySelectActive === true &&
        +store.countryId !== +selectedCountry.id
      ) {
        this.showCountryChange(e, store);
      } else {
        tagmanagerEvents.viewMenu(store.id);

        if (!changeAddress) {
          guardOrderChangeToPickup(
            showOrderGuardModal,
            this.selectStore,
            e,
            false
          );
          return;
        }

        await this.selectStore(e, false);
      }
    };

    const handleSubmit = e => {
      e.stopPropagation();
      if (onViewMenuClick) {
        onViewMenuClick(store, e);
      } else {
        viewMenu(e);
      }
    };

    const handleClick = e => {
      if (onClick) {
        onClick();
      } else {
        viewMenu(e);
      }
    };

    const storeAddress =
      typeof store?.address === "string" ? store.address : "";
    const propAddress = typeof address === "string" ? address : "";
    const bakeryAddressLine =
      storeAddress ||
      propAddress ||
      [mailingAddress, city, state].filter(Boolean).join(", ");
    const featuredUsesBrandRefresh = isBrandRefreshEnabled();

    if (featuredLocation) {
      return (
        <FeaturedLocation
          onClick={handleSubmit}
          icon={
            featuredUsesBrandRefresh ? brandRefreshStorefrontIcon : workIcon
          }
          label={featuredUsesBrandRefresh ? store?.name || "" : ""}
          value={
            featuredUsesBrandRefresh ? bakeryAddressLine : store.name
          }
          dataPart={
            featuredUsesBrandRefresh ? "favorite-bakery" : undefined
          }
        />
      );
    }

    if (isBrandRefresh) {
      const fullAddress = `${mailingAddress}, ${city}, ${state}, ${zip}`;
      const truncatedAddress = truncateBrandRefreshStoreAddress(fullAddress);
      const formattedPhone = formatBrandRefreshStorePhone(telephone);

      return (
        <div
          data-part="store-card-wrapper"
          className={getListItemWrapperClass(styles, isBrandRefresh)}
        >
          <div
            role="button"
            tabIndex="0"
            data-part="store-card"
            onKeyDown={e => {
            if (e.key === "Enter") {
              handleClick(e);
            }
          }}
            onClick={handleClick}
            className={getListItemContainerClass(styles, isBrandRefresh)}
          >
            <header data-part="store-card-header">
              <div data-part="store-title-icon">
                <h3 data-part="store-name">{name}</h3>
                {isDeliveryInRange ? (
                  <div data-part="store-delivery-icon">
                    <img
                      src={scooterBrandRefreshIcon}
                      data-part="store-scooter-icon"
                      alt="Delivery available for this store"
                    />
                  </div>
              ) : null}
              </div>
              <div data-part="store-info">
                {store.storeType === storeTypes.COMINGSOON ? (
                  <>
                    <div data-part="store-status-group">
                      <span data-part="store-status" data-status="coming-soon">
                      Coming Soon
                      </span>
                    </div>
                    {distanceFrom ? (
                      <>
                        <span data-part="store-info-separator" aria-hidden="true">
                        ·
                        </span>
                        <span data-part="store-distance">
                          {formatBrandRefreshStoreDistance(distanceFrom)}
                        </span>
                      </>
                  ) : null}
                  </>
              ) : (
                <>
                  <div data-part="store-status-group">
                    <span
                      data-part="store-status"
                      data-status={isOpen ? 'open' : 'closed'}
                    >
                      {isOpen ? 'Open' : 'Closed'}
                    </span>
                  </div>
                  {hoursStatusText ? (
                    <>
                      <span data-part="store-info-separator" aria-hidden="true">
                        ·
                      </span>
                      <span data-part="store-hours">{hoursStatusText}</span>
                    </>
                  ) : null}
                  {distanceFrom ? (
                    <>
                      <span data-part="store-info-separator" aria-hidden="true">
                        ·
                      </span>
                      <span data-part="store-distance">
                        {formatBrandRefreshStoreDistance(distanceFrom)}
                      </span>
                    </>
                  ) : null}
                </>
              )}
              </div>
            </header>

            <div data-part="store-address-container">
              <div data-part="store-address">
                <p data-part="store-address-line">
                  <span data-part="store-address-full">{fullAddress}</span>
                  <span data-part="store-address-truncated">{truncatedAddress}</span>
                </p>
                <p data-part="store-phone">{formattedPhone}</p>
              </div>
              {canOrder ? (
                <button
                  type="button"
                  data-part="store-view-menu-btn"
                  onClick={handleSubmit}
                >
                  {!changeAddress ? 'View Menu' : 'Selected Store'}
                </button>
            ) : null}
            </div>
          </div>
        </div>
      );
    }

    return (
      <div
        className={getListItemWrapperClass(styles, isBrandRefresh)}
      >
        <div
          role="button"
          tabIndex="0"
          onKeyDown={e => {
            if (e.key === "Enter") {
              handleClick(e);
            }
          }}
          onClick={handleClick}
          className={getListItemContainerClass(styles, isBrandRefresh)}
        >
          <div className={`${styles.listItemHeader} text-dark dark:text-white`}>
            <h3 className="flex items-center gap-2 w-[64%] md:w-full">
              <span>{name}</span>
              <span>
                <img alt="" src={storeImage || infoIcon} />
              </span>
              <div className="has-tooltip">
                <span
                  id={`delivery-tooltip-${store.id}`}
                  className="tooltip rounded shadow-lg p-1 bg-[#ce4396] text-white mt-6 px-2 py-1"
                  role="tooltip"
                  aria-hidden="true"
                >
                  This address is in range of delivery for this store.
                </span>
                {isDeliveryInRange ? (
                  <button
                    type="button"
                    aria-labelledby={`delivery-tooltip-${store.id}`}
                    className="bg-transparent border-none p-0 cursor-pointer !w-[32px] !h-[32px] has-tooltip-button"
                    onFocus={e => {
                      const tooltipContainer = e.currentTarget.closest(
                        ".has-tooltip"
                      );
                      const tooltip = tooltipContainer?.querySelector(
                        `#delivery-tooltip-${store.id}`
                      );
                      if (tooltip) {
                        tooltip.setAttribute("aria-hidden", "false");
                        tooltip.classList.add("tooltip-visible");
                      }
                    }}
                    onBlur={e => {
                      // Don't hide on blur if focus is moving to the tooltip itself
                      const { relatedTarget } = e;
                      const tooltipContainer = e.currentTarget.closest(
                        ".has-tooltip"
                      );
                      const tooltip = tooltipContainer?.querySelector(
                        `#delivery-tooltip-${store.id}`
                      );
                      if (tooltip && !tooltip.contains(relatedTarget)) {
                        tooltip.setAttribute("aria-hidden", "true");
                        tooltip.classList.remove("tooltip-visible");
                      }
                    }}
                    onKeyDown={e => {
                      const tooltipContainer = e.currentTarget.closest(
                        ".has-tooltip"
                      );
                      const tooltip = tooltipContainer?.querySelector(
                        `#delivery-tooltip-${store.id}`
                      );

                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        if (tooltip) {
                          const isHidden =
                            tooltip.getAttribute("aria-hidden") === "true";
                          tooltip.setAttribute(
                            "aria-hidden",
                            isHidden ? "false" : "true"
                          );
                          if (isHidden) {
                            tooltip.classList.add("tooltip-visible");
                          } else {
                            tooltip.classList.remove("tooltip-visible");
                          }
                        }
                      } else if (e.key === "Escape" || e.key === "Esc") {
                        e.preventDefault();
                        if (tooltip) {
                          tooltip.setAttribute("aria-hidden", "true");
                          tooltip.classList.remove("tooltip-visible");
                          // Return focus to button
                          e.currentTarget.focus();
                        }
                      }
                    }}
                  >
                    <img
                      src={DeliveryIcon}
                      alt="Delivery available - This address is in range of delivery for this store"
                    />
                  </button>
                ) : (
                  ""
                )}
              </div>
            </h3>

            {store.storeType === storeTypes.COMINGSOON ? (
              <p className={`${styles.isClosed} `}>
                <span>{"Coming Soon "}</span>
                {`${distanceFrom !== "" ? "|" : ""}`}
                {` ${distanceFrom}`}
              </p>
            ) : (
              <p className={!isOpen ? styles.isClosed : null}>
                <span>{`${isOpen ? "Open " : "Closed "}`}</span>
                {`${distanceFrom !== "" ? "|" : ""}`}
                {` ${distanceFrom}`}
              </p>
            )}
          </div>

          {store.note ? <p>{store.note}</p> : null}

          <div
            className={`${styles.listItemLocation} text-darkElevationPrimary dark:text-darkElevationSecondary flex flex-col gap-2`}
          >
            <p className="truncate overflow-ellipsis overflow-hidden w-[250px]">
              {mailingAddress}
              <br />
              {city}
,
              {state}
,
              {zip}
            </p>
            <p>
              <Link to="/contact" className={styles.listContactLink}>
                {phoneService.applyMask(telephone, phonePrefixes)}
              </Link>
            </p>
          </div>

          {canOrder ? (
            <Button
              handleSubmit={handleSubmit}
              customContainerStyles={`
                      ${styles.customButtonContainer}
                      text-dark dark:text-white
                      py-1
                      border-[1px] border-dark dark:border-light
                      absolute bottom-[30%] md:bottom-[25%]
                      right-[1%]
                      `}
              label={!changeAddress ? "View Menu" : "Selected Store"}
            />
          ) : null}
        </div>
      </div>
    );
  }
}

LocationsListItem.propTypes = {
  preserveProductPage: PropTypes.bool,
  isOpen: PropTypes.bool.isRequired,
  isBrandRefresh: PropTypes.bool,
  hoursStatusText: PropTypes.string,
  storeImage: PropTypes.string.isRequired,
  mailingAddress: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  zip: PropTypes.string.isRequired,
  telephone: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  changeAddress: PropTypes.bool,
  setSelectedStore: PropTypes.func.isRequired,
  store: PropTypes.shape().isRequired,
  onViewMenuClick: PropTypes.func,
  closePopup: PropTypes.func,
  featuredLocation: PropTypes.bool,
  onPickupStoreAddressConfirmed: PropTypes.func,
  history: PropTypes.shape({
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }),
  }),
  addressSource: PropTypes.string,
  address: PropTypes.string,
};

LocationsListItem.defaultProps = {
  preserveProductPage: false,
  changeAddress: false,
  onViewMenuClick: null,
  closePopup: null,
  featuredLocation: false,
  onPickupStoreAddressConfirmed: null,
  history: { location: { pathname: "" } },
  addressSource: null,
  address: null,
  isBrandRefresh: false,
  hoursStatusText: '',
};

export const mapDispatchToProps = dispatch => ({
  setUserCartId: value => dispatch(userActions.setUserCartId(value)),
  setUserOrderMethod: value => dispatch(userActions.setUserOrderMethod(value)),
  setUserAddress: value => dispatch(userActions.setUserAddress(value)),
  setSelectedStore: value => dispatch(userActions.setSelectedStore(value)),
  setModalObject: value => dispatch(elementsActions.setModalObject(value)),
  setSelectedCountry: value =>
    dispatch(countryActions.setSelectedCountry(value)),
  setRedeemableItem: value => dispatch(loyaltyAction.setRedeemableItem(value))
});

export const mapStateToProps = (state, props) => {
  const {
    userCartId,
    selectedMapStore,
    userOrderMethod
  } = state.user;
  const addressComponents =
    props?.addressComponents && Object.keys(props.addressComponents).length > 0
      ? props.addressComponents
      : state.address.addressComponents;
  const {
    phonePrefixes,
    selectedCountry,
    allCountries,
    isCountrySelectActive
  } = state.country;
  const { isShippingActive } = state.shipping;
  const { redeemables } = state.loyalty;
  const orderProducts = state.order?.products || [];
  return {
    userCartId,
    addressComponents,
    selectedMapStore,
    userOrderMethod,
    orderProducts,
    phonePrefixes,
    selectedCountry,
    allCountries,
    isCountrySelectActive,
    isShippingActive,
    redeemables
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LocationsListItem)
);
